import { useEffect, useRef, useState } from 'react';

import invariant from 'tiny-invariant';

import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

import { type IsItemData, type ItemData } from '../dnd-data';

type useDragStateProps<T = unknown> = {
	dragAndDropEnabled?: boolean;
	isItemData: IsItemData<ItemData>;
};
export function useDragState({ dragAndDropEnabled = false, isItemData }: useDragStateProps) {
	const groupDropIndicatorRef = useRef<HTMLDivElement | null>(null);
	const [dragState, setDragState] = useState<'idle' | 'is-over'>('idle');
	const [dragSource, setDragSource] = useState<string | null>(null);
	useEffect(() => {
		if (!dragAndDropEnabled) {
			return;
		}

		const groupDropIndicator = groupDropIndicatorRef.current;
		invariant(groupDropIndicator, 'groupDropIndicatorRef should not be null');
		return dropTargetForElements({
			element: groupDropIndicator,
			canDrop: ({ source }) => isItemData(source.data),
			onDragStart({ source }) {
				setDragSource(source.data.menuItemId as string);
				setDragState('is-over');
			},
			onDragEnter() {
				setDragState('is-over');
			},
			onDragLeave() {
				setDragState('idle');
			},
			onDrop() {
				setDragSource(null);
				setDragState('idle');
			},
		});
	}, [dragAndDropEnabled, isItemData]);

	return {
		groupDropIndicatorRef,
		dragState,
		dragSource,
	};
}
